import React from "react";

import { DEFAULT_CARD_HEIGHT, TAG } from "config/constants";
import TagStreamWrapper from "stream/containers/TagStreamWrapper";
import Stream from "stream/containers/Stream";
import FullStoryCard from "cards/containers/FullStoryCard";
import PromoStreamCap from "stream/components/PromoStreamCap";
import Helmet from "react-helmet-async";
import IssuesModule from "stream/containers/IssuesModule";

import image from "assets/img/future-of-dating-deep-dive.png";
import ogImage from "assets/img/future-of-dating-deep-dive-social.jpg";

export default function FutureOfDatingTagStream() {
  const StreamShoe = () => (
    <IssuesModule
      boxes={[
        {
          name: "Dating apps",
          tagSlug: "dating-apps",
          backgroundColor: "#905cff",
        },
        {
          name: "Online privacy",
          tagSlug: "online-privacy",
          backgroundColor: "#0091ff",
        },
        {
          name: "Facebook",
          tagSlug: "facebook",
          backgroundColor: "#ff69fa",
        },
        {
          name: "Tinder",
          tagSlug: "tinder",
          backgroundColor: "#ff5b47",
        },
      ]}
    />
  );

  return (
    <>
      <Helmet>
        <meta property="og:image" content={ogImage} />
      </Helmet>
      <TagStreamWrapper slug={TAG.FUTURE_OF_DATING.slug}>
        {({ streamParams }) => (
          <>
            <PromoStreamCap
              promo={{
                title: "The gamification of courtship has gone global",
                content: (
                  <span>
                    Explore below and{" "}
                    <a
                      className="gtm-promo-stream-cap-content-link"
                      href="https://signup.axios.com/2019/am.html?source=axios&medium=referral&campaign=stream_cap_promo_link"
                    >
                      sign up for Axios AM{" "}
                    </a>
                    for more deep dives into the most important topics affecting
                    our world.
                  </span>
                ),
                contentForAnalytics:
                  "Explore below and sign up for Axios AM for more deep dives into the most important topics affecting our world.",
                image: image,
              }}
            />
            <Stream
              {...streamParams}
              defaultCardHeight={DEFAULT_CARD_HEIGHT.FULL_STORY_CARD}
              contentComponent={FullStoryCard}
              streamShoeComponent={StreamShoe}
            />
          </>
        )}
      </TagStreamWrapper>
    </>
  );
}
